// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgramForSuccess_wrapper__TGygs","header":"ProgramForSuccess_header__NBTNn"};